export default __webpack_public_path__ + "static/media/culture-large-tablet.2984b747.png";